/* eslint-disable react-hooks/exhaustive-deps */
import NewElectricityAgreementConfirmation from "components/electricity/NewElectricityAgreement/NewElectricityAgreementConfirmation";
import NewElectricityAgreementHeader from "components/electricity/NewElectricityAgreement/NewElectricityAgreementHeader";
import { NewElectricityAgreementSummary } from "components/electricity/NewElectricityAgreement/NewElectricityAgreementSummary";
import FormFooter from "components/FormFooter/FormFooter";
import { ElectricityAgreement } from "models/electricity/agreement";
import { MeteringPoint } from "models/electricity/metering-point";
import { ElectricityAgreementForm, ElectricityPackage, NewElectricityAgreementState } from "models/electricity/new-electricity-agreement";
import React, { useContext, useEffect, useState } from "react";
import { AuthenticationContext, CustomerPermission } from "services/context/authentication.context";
import ElectricityAgreementService from "services/electricity/electricity-agreement.service";
import { toast } from 'react-toastify';
import { Redirect, useHistory, useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { ConfirmAgreementOfferRejectModal } from "components/electricity/NewElectricityAgreement/modal/ConfirmAgreementOfferRejectModal";
import { PageProps } from "models/page";
import { isEmailValidAndPresent, isValidCommaSeperatedEmail, validateBankAccountNumber } from "helpers/validators";
import { normalizeCommaSeparatedEmail } from "helpers";
import moment from "moment";
import { isoDateFormat } from "common/dateFormatterConfig";

export function ViewElectricityOffer(props: PageProps) {
    const [activeMenuOption, setActiveMenuOption] = useState(NewElectricityAgreementState.ACCEPT_TERMS);
    const [currentState, setCurrentState] = useState(NewElectricityAgreementState.ACCEPT_TERMS);
    const [agreementTermsAccepted, setAgreementTermsAccepted] = useState(false);
    const [agreement, setAgreement] = useState<ElectricityAgreement>()
    const [meteringPoints, setMeteringPoints] = useState<MeteringPoint[]>([]);
    const [productionPackage, setProductionPackage] = useState<ElectricityPackage>();
    const [selectedPackage, setSelectedPackage] = useState<ElectricityPackage>();
    const [loading, setLoading] = useState(false);
    const [isLoadingOffer, setIsLoadingOffer] = useState(true);
    const [rejectOfferModalVisible, setRejectOfferModalVisible] = useState(false);

    const [form, setForm] = useState<ElectricityAgreementForm>({
        validated: false,
        sellCheck: false,
        consolidatedInvoice: true,
        eInvoice: false,
        electricityInvoiceRecipientEmailEnabled: false
    });

    const { state, dispatch, hasPermission } = useContext(AuthenticationContext);
    let history = useHistory();

    const params = useParams<{ id?: string }>();

    useEffect(() => {
          props.onLoadValidatePage();
    }, []);

    useEffect(() => {
        if(state.customer && !hasPermission(CustomerPermission.WEB_ADMIN)) history.push("/");
    }, [state.customer])

    const setOffer = (offer: ElectricityAgreement) => {
      setMeteringPoints(offer.meteringPoints.map(mp => ({
          ...mp,
          checked: true
      })));

      setAgreement(offer);

      setForm({
          ...form,
          customerName: offer.customer.name,
          registryNumber: offer.customer.registryNumber,
          email: offer.contactPerson.email,
          phone: offer.contactPerson.phone,
          address: !offer.customer.city ? undefined : offer.customer.address,
          city: offer.customer.city,
          zip: offer.customer.zip,
          county: offer.customer.county,
          bankAccountNumber: offer.customer.bankAccountNumber,
          eInvoice: offer.customer.eInvoice,
          electricityInvoiceRecipientEmail: offer.customer.electricityInvoiceRecipientEmail,
          electricityInvoiceRecipientEmailEnabled: !!offer.customer.electricityInvoiceRecipientEmail
      });

      setSelectedPackage(offer.consumptionPackage);
      setProductionPackage(offer.productionPackage);
      setCurrentState(NewElectricityAgreementState.CONFIRM);
      setActiveMenuOption(NewElectricityAgreementState.CONFIRM);
      setIsLoadingOffer(false);
    }

    const showError = () => {
        toast("Pakkumist ei leitud", { type: 'error' });
        setIsLoadingOffer(false);
    }

    useEffect(() => {
      if(currentState === NewElectricityAgreementState.COMPLETED) return;
      if(!state.customer) return;
      if(!params.id) {
        showError();
        return;
      };

      (async () => {
        try {
            const offer = await ElectricityAgreementService.getElectricityAgreementOffer(
              Number(params.id),
              state.customerId!
            );

            if(!offer) {
              showError();
              return;
            };

            setOffer(offer);
          } catch (e) {
            console.error(e);
            showError();
          }
      })()
      
    }, [state.customer, params.id, currentState]);

    const scrollTop = () => {
        window.scrollTo(0,0)
    }

    const onNext = async () => {
      if(!validateForm()) return;
      setLoading(true);

      let startDate = moment(form.startDate!).startOf('day').add(2, 'hours').format(isoDateFormat);
      if(agreement?.startDate) {
        startDate = moment(agreement?.startDate).startOf('day').add(2, 'hours').format(isoDateFormat);
      }

      try {
        const res = await ElectricityAgreementService.acceptAgreementOffer(
          state.customerId!,
          agreement!.id, 
          {
              startDate: startDate, 
              endDate : agreement?.endDate,
              consolidatedInvoice: form.consolidatedInvoice,
              eInvoice: form.eInvoice,
              email: form.email!,
              phone: form.phone!,
              address: form.address!,
              city: form.city,
              zip: form.zip,
              county: form.county,
              bankAccountNumber: form.eInvoice ? form.bankAccountNumber : undefined, 
              electricityInvoiceRecipientEmail: form.electricityInvoiceRecipientEmailEnabled ? normalizeCommaSeparatedEmail(form.electricityInvoiceRecipientEmail) : undefined, 
          },
          state.customer!.contactId
        );
        
        finalizeNewAgreement(res, NewElectricityAgreementState.COMPLETED);
        scrollTop()
      } catch(e) {
        console.error(e);
      } finally {
        setLoading(false)
      }
    }

    useEffect(() => {
        if (currentState !== NewElectricityAgreementState.COMPLETED) {
            setForm({
                ...form,
                customerName: state.customer?.name,
                registryNumber: state.customer?.registryNumber,
                vatRegistryNumber: state.customer?.vatRegistryNumber,
                bankAccountNumber: state.customer?.bankAccountNumber,
                eInvoice: state.customer?.eInvoice,
                electricityInvoiceRecipientEmail: state.customer?.electricityInvoiceRecipientEmail,
                electricityInvoiceRecipientEmailEnabled: !!state.customer?.electricityInvoiceRecipientEmail,
                email: state.customer?.email,
                phone: state.customer?.phone,
                address: !state.customer?.city ? undefined : state.customer?.address,
                city: state.customer?.city,
                zip: state.customer?.zip,
                county: state.customer?.county,
                startDate: undefined
            });
        }
    }, [state.customer]);

    const validateForm = () => {
        setForm({ ...form, validated: true });
        if (!isEmailValidAndPresent(form.email)) return false;
        if (!form.phone?.trim().length) return false;
        if (!form.address) return false;
        if (form.electricityInvoiceRecipientEmailEnabled && (!form.electricityInvoiceRecipientEmail || !isValidCommaSeperatedEmail(form.electricityInvoiceRecipientEmail))) {
            return false;
        }
        if(form.eInvoice){
            if(!form.bankAccountNumber){
                return false;
            }
            if(!validateBankAccountNumber(form.bankAccountNumber)){
                return false
            }
            return true;
        }
        return true;
    };

    const onPrevious = () => {
        setRejectOfferModalVisible(true);
    }

    const onRejectOffer = () => {
        ElectricityAgreementService.rejectAgreementOffer(state.customerId!, agreement!.id, state.customer!.contactId)
        .then(() => {
            setRejectOfferModalVisible(false);
            toast('Pakkumusest keeldutud', { type: 'warning' });
            history.replace('/lepingud');
        })
    }

    const finalizeNewAgreement = (agreement: ElectricityAgreement, nextState: NewElectricityAgreementState) => {
        setCurrentState(nextState);
        setActiveMenuOption(nextState);
        dispatch({
            type: "setCustomer",
            value: {
                ...state.customer,
                activeElectricityAgreementsCount: state.customer.activeElectricityAgreementsCount + 1,
                address: agreement.customer.address,
                city: agreement.customer.city,
                zip: agreement.customer.zip,
                county: agreement.customer.county
            }
        });
    }

    if (isLoadingOffer) {
        return (
            <div className='d-flex justify-content-center mt-5'>
                <Spinner animation="grow" variant="primary" />
            </div>
        );
    }

    if(!agreement) return <Redirect to='/esileht'/>

    let nextButtonDisabled = !agreementTermsAccepted;

    return (
        <div className="new-electricity-agreement">
            {currentState !== NewElectricityAgreementState.COMPLETED ?
                <NewElectricityAgreementHeader
                    activeItem={activeMenuOption}
                    setActiveItem={() => { return; }}
                    currentItem={currentState}
                    disabled={loading}
                    changingPackage={false}
                    acceptingOffer={true}
                />: null}
            { activeMenuOption === NewElectricityAgreementState.CONFIRM ?
                <NewElectricityAgreementSummary
                    selectedPackage={selectedPackage as ElectricityPackage}
                    productionPackage={productionPackage}
                    selectedMeteringPoints={meteringPoints.filter(mp => mp.checked)}
                    isCompany={state.customer && !state.customer.isPerson && !state.customer.apartmentAssociation}
                    form={form}
                    setForm={setForm}
                    onChangePackage={onPrevious}
                    termsAccepted={agreementTermsAccepted}
                    toggleTerms={() => setAgreementTermsAccepted(!agreementTermsAccepted)}
                    offer={agreement}
                /> : null }
            { activeMenuOption === NewElectricityAgreementState.COMPLETED ?
                <NewElectricityAgreementConfirmation
                    isResaleOffer={false}
                    isChangingPackage={false}
                />: null}                
            {
                hasPermission(CustomerPermission.WEB_ADMIN) && (
                    <FormFooter
                        previous={onPrevious}
                        next={onNext}
                        nextButtonDisabled={nextButtonDisabled}
                        loading={loading}
                        showPrevious={currentState !== NewElectricityAgreementState.COMPLETED}
                        showNext={currentState !== NewElectricityAgreementState.COMPLETED}
                        previousLabel="Loobu"
                        nextLabel="Sõlmi leping"
                    ></FormFooter>
                )
            }
            {rejectOfferModalVisible ? <ConfirmAgreementOfferRejectModal 
                confirm={onRejectOffer}
                cancel={() => setRejectOfferModalVisible(false)}
            /> : null}
        </div>
    )
}